<template>
  <div class="maintenance-content">
    <!-- 维护图标 -->
    <div class="maintenance-icon">
      <div class="icon-wrapper">
       <img src="@/assets/logo.png" alt="">
      </div>
    </div>
    
    <!-- 标题 -->
    <h1 class="maintenance-title">System Maintenance</h1>
    
    <!-- 主要内容 -->
    <div class="maintenance-message">
      <p class="message-text">
        Our system is currently undergoing an upgrade and will be back online as soon as possible. 
        We apologize for any inconvenience this may cause.
      </p>
    </div>
    
    <!-- 联系信息 -->
    <div class="contact-info">
      <p class="contact-text">
        If you have any questions, please contact us at:
      </p>
      <div class="phone-number">
        <i class="iconfont icon-dianhua"></i>
        <span>020-3953-8888</span>
      </div>
    </div>
    
    <!-- 进度条动画 -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
      <p class="progress-text">Upgrading system...</p>
    </div>
    
    <!-- 拨打电话按钮 -->
    <div class="action-buttons">
      <button class="btn-primary" @click="callPhone">
        <i class="iconfont icon-dianhua"></i>
        Call Us Now
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Maintenance',
  metaInfo: {
    meta: ["All Eat - System Maintenance"],
    title: "All Eat - System Maintenance",
  },
  methods: {
    callPhone() {
      // 检测是否为移动设备
      if (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        // 移动设备直接拨打电话
        window.location.href = 'tel:020-3953-8888';
      } else {
        // PC设备显示电话号码
        alert('Please call us at: 020-3953-8888');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.maintenance-content {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 60px 40px;
  text-align: center;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  
  @media (max-width: 768px) {
    padding: 40px 20px;
    margin: 20px;
  }
}

.maintenance-icon {
  margin-bottom: 30px;
  
  .icon-wrapper {
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    animation: pulse 2s infinite;
    
    @media (max-width: 768px) {
      width: 100px;
      height: 100px;
    }
    
    img {
      width: 80px;
      height: 80px;
      object-fit: contain;
      
      @media (max-width: 768px) {
        width: 60px;
        height: 60px;
      }
    }
  }
}

.maintenance-title {
  font-size: 36px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 30px;
  background: linear-gradient(135deg, #09ca6a 0%, #aa0cc0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  
  @media (max-width: 768px) {
    font-size: 28px;
    margin-bottom: 20px;
  }
}

.maintenance-message {
  margin-bottom: 40px;
  
  .message-text {
    font-size: 18px;
    line-height: 1.6;
    color: #5a6c7d;
    margin: 0;
    
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }
}

.contact-info {
  margin-bottom: 40px;
  
  .contact-text {
    font-size: 16px;
    color: #7f8c8d;
    margin-bottom: 15px;
    
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
  
  .phone-number {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 20px;
    font-weight: 600;
    color: #2c3e50;
    
    @media (max-width: 768px) {
      font-size: 18px;
    }
    
    .iconfont {
      color: #27ae60;
      font-size: 18px;
    }
  }
}

.progress-container {
  margin-bottom: 40px;
  
  .progress-bar {
    width: 100%;
    height: 6px;
    background: #ecf0f1;
    border-radius: 3px;
    overflow: hidden;
    margin-bottom: 15px;
    
    .progress-fill {
      height: 100%;
      background: linear-gradient(90deg, #09ca6a 0%, #aa0cc0 100%);
      border-radius: 3px;
      animation: progress 3s ease-in-out infinite;
    }
  }
  
  .progress-text {
    font-size: 14px;
    color: #95a5a6;
    margin: 0;
  }
}

.action-buttons {
  .btn-primary {
    background: linear-gradient(135deg, #09ca6a 0%, #aa0cc0 100%);
    color: white;
    border: none;
    padding: 15px 30px;
    border-radius: 50px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    box-shadow: 0 4px 15px rgba(9, 202, 106, 0.3);
    
    @media (max-width: 768px) {
      padding: 12px 24px;
      font-size: 14px;
    }
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(9, 202, 106, 0.4);
    }
    
    &:active {
      transform: translateY(0);
    }
    
    .iconfont {
      font-size: 16px;
    }
  }
}

// 动画
@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(9, 202, 106, 0.7);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(9, 202, 106, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(9, 202, 106, 0);
  }
}

@keyframes progress {
  0% {
    width: 0%;
  }
  50% {
    width: 70%;
  }
  100% {
    width: 100%;
  }
}

// 响应式设计
@media (max-width: 480px) {
  .maintenance-container {
    padding: 30px 15px;
  }
  
  .maintenance-title {
    font-size: 24px;
  }
  
  .maintenance-message .message-text {
    font-size: 15px;
  }
  
  .contact-info .phone-number {
    font-size: 16px;
  }
}
</style> 